import { BrowserOptions } from '@sentry/nextjs'

export const commonClientConfig: BrowserOptions = {
  debug: false,
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  enabled: process.env.NODE_ENV === 'production',
  integrations: [],
  replaysOnErrorSampleRate: 0.25,
  sampleRate: 0.5,
}

import('@sentry/nextjs').then(lazyLoadedSentry => {
  lazyLoadedSentry.addIntegration(
    lazyLoadedSentry.replayIntegration({
      maskAllText: false,
      networkDetailAllowUrls: [window.location.origin],
    }),
  )
})
